/* Customer artwork is rebuilt from vector geometry before preview, storage or upload. */
(() => {
  'use strict';
  if (window.HHBoardSvg) return;
  const ns = 'http://www.w3.org/2000/svg';
  const maxBytes = 5 * 1024 * 1024;
  const shapes = new Set(['path','rect','circle','ellipse','line','polyline','polygon']);
  const geometry = new Set('d points x y x1 x2 y1 y2 width height cx cy r rx ry'.split(' '));
  const paint = new Set('fill fill-rule fill-opacity stroke stroke-width stroke-opacity stroke-linecap stroke-linejoin stroke-miterlimit stroke-dasharray stroke-dashoffset opacity transform vector-effect'.split(' '));
  const unsafe = () => Error('Die SVG enthält Anweisungen, die der Designer nicht übernehmen kann. Bitte exportiere das Motiv als eigenständige SVG.');
  const safeName = name => String(name || 'Gravur.svg').replace(/[<>:"/\\|?*\u0000-\u001f]/g,'_').replace(/\.svg$/i,'').slice(0,80) + '.svg';
  let lastSource, lastResult;
  function parse(source) {
    if (source === lastSource && lastResult) return lastResult;
    if (typeof source !== 'string' || source.length > maxBytes) throw unsafe();
    // Illustrator's standard declaration carries no user entities. Strip it without resolving a DTD.
    const xml=source.replace(/<!DOCTYPE\s+svg\s+PUBLIC\s+["']-\/\/W3C\/\/DTD SVG 1\.1\/\/EN["']\s+["']https?:\/\/www\.w3\.org\/Graphics\/SVG\/1\.1\/DTD\/svg11\.dtd["']\s*>/i,'');
    if (/<!DOCTYPE|<!ENTITY|<\?xml-stylesheet/i.test(xml)) throw unsafe();
    const root = new DOMParser().parseFromString(xml,'image/svg+xml').documentElement;
    if (root.localName !== 'svg' || (root.namespaceURI && root.namespaceURI !== ns) || root.querySelector('parsererror')) throw Error('Die Datei ist keine gültige SVG.');
    const descendants=[...root.querySelectorAll('*')];
    if(descendants.length>5000)throw Error('Das Motiv hat zu viele Einzelteile. Bitte vereinfache die Pfade.');
    const ids=new Map(),rules=[];
    for(const el of descendants){
      if(el.id)ids.set(el.id,el);
      if(el.localName!=='style')continue;
      let css=el.textContent.replace(/\/\*[\s\S]*?\*\//g,'').trim();
      while(css){
        const rule=/^([^{}]+)\{([^{}]*)\}/.exec(css);
        if(!rule)throw unsafe();
        for(const selector of rule[1].split(',').map(v=>v.trim())){
          if(!/^(?:[a-zA-Z][\w-]*)?(?:[.#][\w-]+)?$/.test(selector)||!selector||rules.length>=160)throw unsafe();
          rules.push({selector,body:rule[2],priority:(selector.includes('#')?100:selector.includes('.')?10:0)+(/^[a-z]/i.test(selector)?1:0)});
        }
        css=css.slice(rule[0].length).trim();
      }
    }
    rules.sort((a,b)=>a.priority-b.priority);
    let box = (root.getAttribute('viewBox') || '').trim().split(/[\s,]+/).map(Number);
    const unit = value => { const m = /^(\d+(?:\.\d+)?)(px|mm|cm|in|pt)?$/.exec(value || ''); return m ? Number(m[1])*({mm:96/25.4,cm:96/2.54,in:96,pt:96/72}[m[2]] || 1) : NaN; };
    if (!root.hasAttribute('viewBox')) box = [0,0,unit(root.getAttribute('width')),unit(root.getAttribute('height'))];
    if (box.length !== 4 || !box.every(Number.isFinite) || box[2] <= 0 || box[3] <= 0) throw Error('Die SVG braucht eine gültige Zeichenfläche (viewBox oder Breite und Höhe).');
    const doc = document.implementation.createDocument(ns,'svg',null);
    const clean = doc.documentElement;
    let count = 0, expanded=0;
    function copy(el, parent, depth) {
      if (depth > 64 || ++expanded>6000) throw unsafe();
      const tag = el.localName;
      if (tag === 'metadata' || tag === 'title' || tag === 'desc' || (el.namespaceURI !== ns && /inkscape|sodipodi/i.test(el.namespaceURI || ''))) return;
      if (el.namespaceURI !== root.namespaceURI && el.namespaceURI !== ns) throw unsafe();
      if (tag === 'text' || tag === 'tspan') throw Error('Bitte wandle den Text in deinem Grafikprogramm in Pfade um und lade die SVG erneut hoch.');
      if (tag==='style'||tag==='defs')return;
      if (tag==='image')throw Error('Die SVG enthält ein eingebettetes Bild. Bitte exportiere das Logo als Vektorpfade.');
      const isUse=tag==='use';
      if (el !== root && tag !== 'g' && !isUse && !shapes.has(tag)) throw unsafe();
      const target = el === root ? clean : doc.createElementNS(ns,isUse?'g':tag);
      const assign = (key,val) => {
        val = val.trim();
        if (key==='display'){if(val==='none'){target.setAttribute('display','none');return;}if(['inline','block'].includes(val))return;}
        if (['stroke','fill'].includes(key)&&val.toLowerCase()==='currentcolor')val='#000';
        if (['enable-background','shape-rendering','text-rendering','color-rendering','color-interpolation','paint-order','color'].includes(key))return;
        if (!paint.has(key) && !geometry.has(key)) throw unsafe();
        if (!/^[a-zA-Z0-9 .,()%#+\-\s]+$/.test(val) || /url|expression|var\s*\(/i.test(val)) throw unsafe();
        target.setAttribute(key,val);
      };
      for (const a of el.attributes) {
        if (a.name === 'xmlns' || a.name.startsWith('xmlns:') || a.name.startsWith('data-') || a.name.startsWith('aria-') || ['id','class','version','role','xml:space','baseProfile','focusable'].includes(a.name) || (el === root && ['viewBox','width','height','preserveAspectRatio'].includes(a.name))) continue;
        if (/inkscape|sodipodi/i.test(a.namespaceURI || '')) continue;
        if(isUse&&['href','xlink:href','x','y','width','height'].includes(a.name))continue;
        if (a.name === 'style') continue;
        assign(a.name,a.value);
      }
      const styles=rules.filter(rule=>el.matches(rule.selector)).map(rule=>rule.body);
      if(el.hasAttribute('style'))styles.push(el.getAttribute('style'));
      for (const part of styles.join(';').split(';').filter(x=>x.trim())) {
        const i=part.indexOf(':'); if(i<1) throw unsafe();
        assign(part.slice(0,i).trim(),part.slice(i+1));
      }
      if(target.getAttribute('display')==='none'){if(el===root)throw Error('Die SVG enthält kein sichtbares Motiv.');return;}
      if (el !== root) parent.append(target);
      if(isUse){
        const href=el.getAttribute('href')||el.getAttribute('xlink:href')||'';
        const src=href.startsWith('#')?ids.get(href.slice(1)):null;
        if(!src||src.localName==='symbol')throw unsafe();
        const x=Number(el.getAttribute('x')||0),y=Number(el.getAttribute('y')||0);
        if(![x,y].every(Number.isFinite))throw unsafe();
        if(x||y)target.setAttribute('transform',(target.getAttribute('transform')||'')+' translate('+x+' '+y+')');
        copy(src,target,depth+1);return;
      }
      if (shapes.has(tag)) count++;
      for (const child of el.children) copy(child,target,depth+1);
    }
    copy(root,null,0);
    if (!count) throw Error('Diese SVG enthält keine gravierbaren Formen.');
    clean.setAttribute('viewBox',box.join(' '));
    for (const axis of ['width','height']) if (/^\d+(?:\.\d+)?(?:mm|cm|px|in|pt)?$/.test(root.getAttribute(axis)||'')) clean.setAttribute(axis,root.getAttribute(axis));
    // Some exporters add an opaque white page behind the actual logo.
    const first=clean.querySelector('path,rect,circle,ellipse,line,polyline,polygon');
    const white=value=>/^(?:white|#fff(?:fff)?|rgb\(\s*255\s*,\s*255\s*,\s*255\s*\))$/i.test(value||'');
    const coord=(el,k,fallback)=>el.hasAttribute(k)?Number(el.getAttribute(k)):fallback;
    if(first?.localName==='rect' && first.parentNode===clean && !first.hasAttribute('transform') &&
       white(first.getAttribute('fill')||clean.getAttribute('fill')) && (!first.hasAttribute('stroke')||first.getAttribute('stroke')==='none') &&
       coord(first,'x',0)<=box[0] && coord(first,'y',0)<=box[1] &&
       coord(first,'x',0)+coord(first,'width',0)>=box[0]+box[2] &&
       coord(first,'y',0)+coord(first,'height',0)>=box[1]+box[3] && count>1)first.remove();
    const svg=new XMLSerializer().serializeToString(clean);
    const result={svg,box};
    lastSource=source; lastResult=result; return result;
  }
  function embeddedImage(value,maxPixels=16000000) {
    const m=/^data:image\/(png|jpeg);base64,([\sa-z0-9+/=]+)$/i.exec(value);
    if(!m)throw Error('Bitte bette dein Bild als PNG oder JPEG direkt in die SVG ein.');
    let bytes;
    try{bytes=atob(m[2]);}catch{throw Error('Das eingebettete Bild ist beschädigt.');}
    const u16=i=>(bytes.charCodeAt(i)<<8)+bytes.charCodeAt(i+1);
    let w=0,h=0;
    if(m[1].toLowerCase()==='png'&&bytes.startsWith('\x89PNG\r\n\x1a\n')&&bytes.slice(12,16)==='IHDR'){
      w=u16(16)*65536+u16(18);h=u16(20)*65536+u16(22);
    }else if(bytes.startsWith('\xff\xd8')){
      for(let i=2;i+8<bytes.length;){
        if(bytes.charCodeAt(i++)!==255)break;
        while(bytes.charCodeAt(i)===255)i++;
        const marker=bytes.charCodeAt(i++),len=u16(i);
        if([192,193,194].includes(marker)){h=u16(i+3);w=u16(i+5);break;}
        if(len<2||marker===218||marker===217)break;i+=len;
      }
    }
    if(!w||!h||w*h>maxPixels)throw Error('Bitte verkleinere das eingebettete Bild und exportiere die SVG erneut.');
    return w*h;
  }

  // Only this monochrome snapshot is stored for logos that need browser rendering.
  // Customer markup is decoded as an image and is never mounted or sent to Shopify.
  async function renderLogo(xml) {
    if(/<!ENTITY|<\?xml-stylesheet/i.test(xml))throw unsafe();
    if(/<!DOCTYPE[^>]*\[/i.test(xml))throw unsafe();
    const doc=new DOMParser().parseFromString(xml,'image/svg+xml'),root=doc.documentElement;
    if(root.localName!=='svg'||root.namespaceURI!==ns||doc.querySelector('parsererror')||
       (doc.doctype&&(doc.doctype.internalSubset||!/^-\/\/W3C\/\/DTD SVG 1\.1\/\/EN$/.test(doc.doctype.publicId))))throw unsafe();
    root.querySelectorAll('metadata,title,desc').forEach(e=>e.remove());
    for(const el of root.querySelectorAll('*')){
      if(el.namespaceURI!==ns&&/inkscape|sodipodi|ns\.adobe\.com/i.test(el.namespaceURI||''))el.remove();
    }
    const nodes=[root,...root.querySelectorAll('*')];
    if(nodes.length>5000)throw Error('Das Motiv hat zu viele Einzelteile.');
    const allowed=new Set('svg g path rect circle ellipse line polyline polygon text tspan textPath image defs style clipPath mask linearGradient radialGradient stop use symbol pattern switch'.split(' '));
    let pixels=0,uses=0;
    function css(text){
      if(/@|\\|\/\*|(?:https?:|javascript:|data:|expression\s*\()/i.test(text))throw unsafe();
      if(/url\s*\(/i.test(text.replace(/url\(\s*(['"]?)#[\w.-]+\1\s*\)/gi,'')))throw Error('Die SVG verweist auf eine externe Datei. Bitte bette das Motiv direkt ein.');
    }
    for(const el of nodes){
      if(el.namespaceURI!==ns||!allowed.has(el.localName))throw Error('Dieses SVG-Element kann der Designer nicht übernehmen: '+el.localName.slice(0,50)+'. Bitte vereinfache es in deinem Grafikprogramm.');
      if(el.localName==='use'&&++uses>100)throw unsafe();
      if(el.localName==='style')css(el.textContent);
      for(const a of [...el.attributes]){
        if(/^on/i.test(a.localName)||a.localName==='base')throw unsafe();
        if(a.localName==='href'){
          if(el.localName==='image')pixels+=embeddedImage(a.value);
          else if(!/^#[\w.-]+$/.test(a.value))throw Error('Die SVG verweist auf eine externe Datei. Bitte bette das Motiv direkt ein.');
        }else if(a.localName==='style'||/url\s*\(/i.test(a.value))css(a.value);
      }
    }
    if(pixels>24000000)throw Error('Die eingebetteten Bilder sind zu groß.');
    const b=(root.getAttribute('viewBox')||'').trim().split(/[\s,]+/).map(Number);
    const length=value=>{const m=/^(\d*\.?\d+)(px|mm|cm|in|pt)?$/.exec(value||'');return m?Number(m[1])*({mm:96/25.4,cm:96/2.54,in:96,pt:96/72}[m[2]]||1):NaN;};
    if(!root.hasAttribute('viewBox'))b.splice(0,b.length,0,0,length(root.getAttribute('width')),length(root.getAttribute('height')));
    if(b.length!==4||!b.every(Number.isFinite)||b[2]<=0||b[3]<=0)throw Error('Die SVG braucht eine gültige Zeichenfläche.');
    const scale=1600/Math.max(b[2],b[3]),w=Math.max(1,Math.round(b[2]*scale)),h=Math.max(1,Math.round(b[3]*scale));
    root.setAttribute('width',w);root.setAttribute('height',h);root.setAttribute('viewBox',b.join(' '));
    const url=URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(root)],{type:'image/svg+xml'}));
    try{
      const img=new Image();img.src=url;await img.decode();
      return engravingPixels(img,w,h,true);
    }finally{URL.revokeObjectURL(url);}
  }

  function engravingPixels(img,w,h,trim) {
      const canvas=document.createElement('canvas');canvas.width=w;canvas.height=h;
      const ctx=canvas.getContext('2d',{willReadFrequently:true});ctx.drawImage(img,0,0,w,h);
      const image=ctx.getImageData(0,0,w,h),p=image.data;
      let L=w,T=h,R=-1,B=-1;
      for(let y=0,i=0;y<h;y++)for(let x=0;x<w;x++,i+=4){
        const ink=1-(p[i]*.2126+p[i+1]*.7152+p[i+2]*.0722)/255;
        p[i+3]=Math.round(p[i+3]*ink);
        if(p[i+3]>3){L=Math.min(L,x);R=Math.max(R,x);T=Math.min(T,y);B=Math.max(B,y);}
        p[i]=p[i+1]=p[i+2]=0;
      }
      if(R<L)throw Error('Die SVG enthält keine sichtbaren Gravurlinien. Bitte verwende ein dunkles Motiv.');
      ctx.putImageData(image,0,0);
      if(!trim){L=0;T=0;R=w-1;B=h-1;}
      const crop=document.createElement('canvas');crop.width=R-L+1;crop.height=B-T+1;
      const ink=crop.getContext('2d');ink.drawImage(canvas,-L,-T);
      const png=crop.toDataURL('image/png'),cw=crop.width,ch=crop.height;
      const svg='<svg xmlns="'+ns+'" width="'+cw+'" height="'+ch+'" viewBox="0 0 '+cw+' '+ch+'"><image width="'+cw+'" height="'+ch+'" href="'+png+'"/></svg>';
      ink.globalCompositeOperation='source-in';ink.fillStyle='#725136';ink.fillRect(0,0,cw,ch);
      return {svg,preview:crop.toDataURL('image/png')};
  }

  function photoName(name,mime){
    return String(name||'Foto').replace(/[<>:"/\\|?*\u0000-\u001f]/g,'_').replace(/\.[^.]+$/,'').slice(0,90)+(mime==='image/png'?'.png':'.jpg');
  }
  async function readPhoto(file){
    const mime=/\.png$/i.test(file.name)?'image/png':'image/jpeg',blob=new Blob([file],{type:mime});
    const original=await new Promise((resolve,reject)=>{const r=new FileReader();r.onload=()=>resolve(r.result);r.onerror=reject;r.readAsDataURL(blob);});
    embeddedImage(original,32000000);
    const img=new Image(),url=URL.createObjectURL(blob);
    try{
      img.src=url;await img.decode();
      const scale=Math.min(1,1400/Math.max(img.naturalWidth,img.naturalHeight));
      const art=engravingPixels(img,Math.max(1,Math.round(img.naturalWidth*scale)),Math.max(1,Math.round(img.naturalHeight*scale)),false);
      const name=photoName(file.name,mime);
      return {...art,name:safeName(name.replace(/\.[^.]+$/,'')),photo:{name,mime,data:original}};
    }finally{URL.revokeObjectURL(url);}
  }

  async function readFile(file) {
    if (!file || !/\.(?:svg|png|jpe?g)$/i.test(file.name)) throw Error('Bitte wähle eine JPG-, PNG- oder SVG-Datei.');
    if (!file.size || file.size>maxBytes) throw Error('Bitte wähle eine Datei mit höchstens 5 MB.');
    if(!/\.svg$/i.test(file.name))return readPhoto(file);
    const source=await file.text(),name=safeName(file.name);
    try {
      const original=parse(source).svg;
      return {name,svg:boardVector(original),original};
    } catch(vectorError) {
      return {name,...await renderLogo(source)};
    }
  }
  // Give small viewBoxes enough preview pixels and match the single engraving layer.
  function boardVector(svg) {
    const box=parse(svg).box;
    const root=new DOMParser().parseFromString(svg,'image/svg+xml').documentElement;
    const doc=document.implementation.createDocument(ns,'svg',null),out=doc.documentElement;
    const scale=900/Math.max(box[2],box[3]),w=box[2]*scale,h=box[3]*scale;
    out.setAttribute('viewBox','0 0 '+w+' '+h);
    const group=doc.createElementNS(ns,'g');group.setAttribute('transform','scale('+scale+') translate('+(-box[0])+' '+(-box[1])+')');out.append(group);
    const inner=doc.createElementNS(ns,'g');group.append(inner);
    for(const a of root.attributes)if(paint.has(a.name))inner.setAttribute(a.name,a.value);
    for(const el of root.children)inner.append(doc.importNode(el,true));
    const white=value=>/^(?:white|#fff(?:fff)?|rgb\(\s*255\s*,\s*255\s*,\s*255\s*\))$/i.test(value);
    const solid=value=>!['none','transparent'].includes(value);
    const effective=(el,k,fallback)=>{for(let n=el;n;n=n.parentElement)if(n.hasAttribute(k))return n.getAttribute(k);return fallback;};
    const mixedInk=[...inner.querySelectorAll('path,rect,circle,ellipse,line,polyline,polygon')].some(el=>
      [effective(el,'fill','black'),effective(el,'stroke','none')].some(v=>solid(v)&&!white(v)));
    for(const node of [inner,...inner.querySelectorAll('*')]){
      for(const key of ['fill','stroke']){
        const v=node.getAttribute(key);if(!v||v==='none')continue;
        if(mixedInk&&white(v))throw Error('Deine SVG enthält weiße Flächen. Bitte spare sie aus und exportiere das Motiv ohne weißen Hintergrund.');
        if(v==='transparent'){node.setAttribute(key,'none');continue;}
        node.setAttribute(key,'#725136');
      }
    }
    if(!inner.hasAttribute('fill'))inner.setAttribute('fill','#725136');
    return new XMLSerializer().serializeToString(out);
  }
  const uploads=host=>host.state.motifs.filter(m=>{
    const a=host.customAssets?.[m.uploadKey];return a?.mode==='engraved'&&a.mime==='image/svg+xml';
  });
  function sync(host) {
    const panel=host.boardSvgPanel;
    const active=Array.isArray(host.state?.motifs);
    if(panel.dataset.forBlank!==host.blankId){panel.querySelector('[data-board-feedback]').textContent='';panel.dataset.forBlank=host.blankId;}
    panel.hidden=!active;
    const legacy=host.querySelector('[data-own-upload]');
    if(legacy){legacy.dataset.standardAccept??=legacy.accept;const accept=active?panel.querySelector('[data-board-file]').accept:legacy.dataset.standardAccept;if(legacy.accept!==accept)legacy.accept=accept;}
    if(!active){panel.querySelector('[data-board-feedback]').textContent='';return;}
    const items=uploads(host),checkbox=panel.querySelector('[data-board-service]');
    panel.inert=!!host.orderBusy;
    if(!items.length)host.state.boardImageService=false;
    checkbox.checked=!!host.state.boardImageService&&!!panel.dataset.serviceId;
    checkbox.disabled=!items.length||!panel.dataset.serviceId||host.uploadBusy||host.orderBusy;
    panel.querySelector('[data-service-unavailable]').hidden=!!panel.dataset.serviceId;
    const selector=panel.querySelector('[data-board-choice]');
    if(items.map(i=>i.uid).join('|')!==panel.dataset.items){
      panel.dataset.items=items.map(i=>i.uid).join('|');
      selector.replaceChildren(...items.map(i=>new Option(host.customAssets[i.uploadKey].boardPhoto?.name||host.customAssets[i.uploadKey].name,i.uid)));
    }
    const item=items.find(i=>i.uid===host.selectedMotif)||items.find(i=>i.uid===selector.value)||items[0];
    panel.querySelector('[data-board-edit]').hidden=!item;
    if(item){selector.value=item.uid;panel.querySelector('[data-board-scale]').value=item.size;}
  }
  function bind(host,listen,artwork) {
    const panel=host.querySelector('[data-board-svg]');if(!panel)return;
    host.boardSvgPanel=panel;
    const input=panel.querySelector('[data-board-file]'),status=panel.querySelector('[data-board-feedback]');
    const center=i=>{const b=host.blank(),area=b.editable;const target=area?{x:(area.left+area.right)/2,y:(area.top+area.bottom)/2}:b.motif||{x:b.width/2,y:b.height/2};Object.assign(i,{x:target.x,y:target.y});};
    const selected=()=>uploads(host).find(i=>i.uid===panel.querySelector('[data-board-choice]').value);
    const edit=fn=>{const item=selected();if(!item||host.orderBusy||host.uploadBusy)return;host.selectedMotif=item.uid;fn(item);host.selectArtwork('motif');host.renderMotif();host.$('[data-order-confirm]').checked=false;host.updateOrderAvailability();};
    listen(panel.querySelector('[data-board-choice]'),'change',()=>edit(()=>{}));
    listen(panel.querySelector('[data-board-scale]'),'input',e=>edit(i=>{i.size=Number(e.target.value);}));
    listen(panel.querySelector('[data-board-center]'),'click',()=>edit(center));
    listen(panel.querySelector('[data-board-remove]'),'click',()=>{const item=selected();if(item&&!host.uploadBusy&&!host.orderBusy){host.removeMotif(item.uid);status.textContent='Das Motiv wurde entfernt.';}});
    const legacy=host.querySelector('[data-own-upload]');
    async function accept(picker){
      const f=picker.files[0];if(!f||!host.state)return;
      const report=message=>{status.textContent=message;if(picker===legacy)host.querySelector('[data-own-status]').textContent=message;};
      if(host.uploadBusy||host.orderBusy){report('Bitte warte, bis der laufende Vorgang beendet ist.');picker.value='';return;}
      if(host.state.motifs.filter(m=>m.uploadKey).length>=3){report('Bis zu drei eigene Motive sind möglich. Entferne zuerst ein Motiv.');picker.value='';return;}
      const state=host.state;
      host.uploadBusy=true;input.disabled=true;host.updateOrderAvailability();report('Dein Motiv wird geprüft …');
      try{
        const clean=await readFile(f);
        const asset=await artwork.load(new File([clean.svg],clean.name,{type:'image/svg+xml'}));
        if(host.state!==state)throw Error('Der Rohling wurde gewechselt. Bitte wähle die Datei für deinen Rohling erneut aus.');
        Object.assign(asset,{key:'neu-zip-upload-'+crypto.randomUUID(),mode:'engraved',transparent:true,boardSource:clean.original||null,boardPhoto:clean.photo||null});
        if(clean.preview)asset.data=clean.preview;
        if(!host.registerUpload(asset))throw Error('Die SVG konnte nicht als Gravurmotiv übernommen werden.');
        host.addMotif(asset.key);
        const item=host.currentMotifInstance();if(!item||item.type!==asset.key)throw Error('Bitte entferne zuerst ein Motiv.');
        center(item);Object.assign(item,{size:100,backgroundRemoval:false});
        host.state.uploads??={};host.state.uploads[asset.key]=asset;host.renderMotif();host.renderPrice();
        host.closeMobileSheet(false);host.dataset.mobilePreview='large';host.$('[data-order-confirm]').checked=false;
        report((clean.photo?.name||clean.name)+' liegt auf deinem Rohling. '+(clean.preview?'Als Gravurbild übernommen. Prüfe Schrift und Details in der Vorschau.':'Ziehe das Motiv an die gewünschte Stelle.'));
        host.$('.hhd-stage').scrollIntoView({block:'nearest'});
      }catch(e){report(e.message&&e.message.length>12?e.message:'Diese SVG lässt sich nicht als Gravur verwenden. Bitte exportiere sie mit Vektorpfaden.');}
      finally{picker.value='';host.uploadBusy=false;input.disabled=false;sync(host);host.updateOrderAvailability();}
    }
    listen(panel.querySelector('[data-board-service]'),'change',e=>{
      host.state.boardImageService=e.target.checked&&!!panel.dataset.serviceId&&uploads(host).length>0;
      host.$('[data-order-confirm]').checked=false;host.renderPrice();host.updateOrderAvailability();host.queueDraftSave?.();
    });
    listen(input,'change',()=>accept(input));
    if(legacy)listen(legacy,'change',e=>{
      if(!legacy.files[0]||(host.$('[data-own-mode]')?.value==='color'&&!host.blank().engravingOnly&&!host.blank().pendant)||!/\.(?:svg|png|jpe?g)$/i.test(legacy.files[0].name))return;
      e.stopImmediatePropagation();accept(legacy);
    },{capture:true});
  }
  function attach(host,body) {
    const keys=[],originals=[];
    for(const [n,i] of uploads(host).entries()){
      const a=host.customAssets[i.uploadKey],key='Gravurdatei '+(n+1);
      const svg=a.boardSource?parse(a.boardSource).svg:a.svg;
      body.append('properties['+key+']',new Blob([svg],{type:'image/svg+xml'}),safeName(a.name));keys.push(key);
      if(!a.boardPhoto)continue;
      const {data,name,mime}=a.boardPhoto;
      if(!['image/png','image/jpeg'].includes(mime)||typeof data!=='string'||data.length>maxBytes*4/3+64||!data.startsWith('data:'+mime+';base64,'))throw Error('Bitte lade die Bildvorlage erneut hoch.');
      embeddedImage(data,32000000);
      const bytes=Uint8Array.from(atob(data.slice(data.indexOf(',')+1)),c=>c.charCodeAt(0));
      originals.push({name:(n+1)+'-'+photoName(name,mime),data:bytes});
    }
    if(originals.length){
      body.append('properties[Originalbilder]',window.HHDProduction.zip(originals),'Originalbilder.zip');
      keys.push('Originalbilder');
    }
    return keys;
  }
  function service(host){
    return host.state?.boardImageService===true&&uploads(host).length>0?(host.boardSvgPanel?.dataset.serviceId||''):'';
  }
  function cartWithService(form,id,designId){
    const body=new FormData(),grouped=form.has('items[0][id]');
    for(const [key,value] of form){
      const target=grouped?key:key.startsWith('properties[')?'items[0][properties]'+key.slice(10):'items[0]['+key+']';
      if(value instanceof File)body.append(target,value,value.name);else body.append(target,value);
    }
    let index=1;while(body.has('items['+index+'][id]'))index++;
    const prefix='items['+index+']';
    body.append(prefix+'[id]',id);
    body.append(prefix+'[quantity]','1');
    body.append(prefix+'[parent_id]',body.get('items[0][id]'));
    body.append(prefix+'[properties][_HH_Bildservice]',designId);
    body.append(prefix+'[properties][Bearbeitung]','Bild für die Wunschgravur aufbereiten');
    return body;
  }
  function serviceMatches(lines,id,designId,parent){
    if(!id)return true;
    const item=lines?.find(line=>String(line.variant_id)===String(id)&&line.properties?._HH_Bildservice===designId);
    return !!parent&&!!item&&item.parent_relationship?.parent_key===parent.key&&item.quantity===1&&Number(item.original_price??item.price)===200;
  }
  function uploaded(value){
    try{const u=new URL(value);return u.protocol==='https:'&&!u.username&&!u.password&&!u.port&&((u.hostname==='cdn.shopify.com'&&u.pathname.startsWith('/s/files/1/0950/1219/2629/'))||(u.hostname===location.hostname&&u.pathname.startsWith('/cdn/shop/files/')));}catch{return false;}
  }
const crcTable=Array.from({length:256},(_,n)=>{for(let i=0;i<8;i++)n=n&1?0xedb88320^(n>>>1):n>>>1;return n>>>0;});
function crc(data){let v=0xffffffff;for(const b of data)v=crcTable[(v^b)&255]^(v>>>8);return (v^0xffffffff)>>>0;}
function zipOriginals(files){const encoder=new TextEncoder(),parts=[],directory=[];let offset=0,dirSize=0;for(const file of files){const name=encoder.encode(file.name),data=typeof file.data==='string'?encoder.encode(file.data):file.data,c=crc(data);const local=new Uint8Array(30+name.length),v=new DataView(local.buffer);v.setUint32(0,0x04034b50,true);v.setUint16(4,20,true);v.setUint16(6,0x800,true);v.setUint16(12,33,true);v.setUint32(14,c,true);v.setUint32(18,data.length,true);v.setUint32(22,data.length,true);v.setUint16(26,name.length,true);local.set(name,30);const central=new Uint8Array(46+name.length),d=new DataView(central.buffer);d.setUint32(0,0x02014b50,true);d.setUint16(4,20,true);d.setUint16(6,20,true);d.setUint16(8,0x800,true);d.setUint16(14,33,true);d.setUint32(16,c,true);d.setUint32(20,data.length,true);d.setUint32(24,data.length,true);d.setUint16(28,name.length,true);d.setUint32(42,offset,true);central.set(name,46);parts.push(local,data);directory.push(central);offset+=local.length+data.length;dirSize+=central.length;}const end=new Uint8Array(22),v=new DataView(end.buffer);v.setUint32(0,0x06054b50,true);v.setUint16(8,files.length,true);v.setUint16(10,files.length,true);v.setUint32(12,dirSize,true);v.setUint32(16,offset,true);return new Blob([...parts,...directory,end],{type:'application/zip'});}
  // The secondary designers place the same validated artwork in their native engraving layer.
  const geometryCache=new Map();
  function artGeometry(svg){
    if(geometryCache.has(svg))return geometryCache.get(svg);
    let result;
    try{result=parse(svg);}
    catch(e){
      // The bitmap importer emits only this envelope. Imported drafts must pass the same checks.
      if(typeof svg!=='string'||svg.length>maxBytes*1.5)throw e;
      const m=/^<svg xmlns="http:\/\/www\.w3\.org\/2000\/svg" width="(\d+)" height="(\d+)" viewBox="0 0 (\d+) (\d+)"><image width="(\d+)" height="(\d+)" href="(data:image\/png;base64,[a-zA-Z0-9+/=]+)"\/><\/svg>$/.exec(svg);
      if(!m||m[1]!==m[3]||m[1]!==m[5]||m[2]!==m[4]||m[2]!==m[6]||embeddedImage(m[7])!==Number(m[1])*Number(m[2]))throw e;
      result={svg,box:[0,0,Number(m[1]),Number(m[2])]};
    }
    const doc=new DOMParser().parseFromString(result.svg,'image/svg+xml'),el=doc.documentElement;
    el.removeAttribute('width');el.removeAttribute('height');
    const info={...result,scalable:new XMLSerializer().serializeToString(el)};
    if(geometryCache.size>=10)geometryCache.delete(geometryCache.keys().next().value);
    geometryCache.set(svg,info);return info;
  }
  function restored(value){
    if(!value||typeof value.name!=='string')throw Error('Ungültige Gravurvorlage.');
    const art={name:safeName(value.name),svg:artGeometry(value.svg).svg};
    if(value.original)art.original=parse(value.original).svg;
    if(value.photo){
      const {mime,name,data}=value.photo;
      if(!['image/png','image/jpeg'].includes(mime)||typeof data!=='string'||data.length>maxBytes*4/3+64||!data.startsWith('data:'+mime+';base64,'))throw unsafe();
      if(data!==lastPhoto){embeddedImage(data,32000000);lastPhoto=data;}
      art.photo={mime,name:photoName(name,mime),data};
    }
    return art;
  }
  let lastPhoto;
  async function portableFile(file){
    const a=await readFile(file);
    return restored({name:a.name,svg:a.svg,original:a.original,photo:a.photo});
  }
  function placed(art,x,y,w,h){
    if(![x,y,w,h].every(Number.isFinite)||w<=0||h<=0)throw unsafe();
    return artGeometry(art.svg).scalable.replace('<svg ','<svg x="'+x+'" y="'+y+'" width="'+w+'" height="'+h+'" ');
  }
  function originals(arts){
    const files=[];
    for(const [i,art] of arts.entries()){
      if(!art.photo)continue;
      const p=restored(art).photo;
      files.push({name:(i+1)+'-'+p.name,data:Uint8Array.from(atob(p.data.slice(p.data.indexOf(',')+1)),c=>c.charCodeAt(0))});
    }
    return files.length?zipOriginals(files):null;
  }
  function appendArts(body,arts,keyFor=i=>'Gravurdatei '+(i+1)){
    const keys=arts.map((value,i)=>{
      const a=restored(value),key=keyFor(i);
      body.append('properties['+key+']',new Blob([a.original||a.svg],{type:'image/svg+xml'}),safeName(a.name));
      return key;
    });
    const archive=originals(arts);
    if(archive){body.append('properties[Originalbilder]',archive,'Originalbilder.zip');keys.push('Originalbilder');}
    return keys;
  }
  function servicePanel(root,state,hasArt){
    const panel=root.querySelector('[data-gravur-panel]'),checkbox=panel?.querySelector('[data-gravur-service]');
    if(!checkbox)return '';
    const id=panel.dataset.serviceId||'';
    if(!hasArt)state.gravurService=false;
    checkbox.disabled=!hasArt||!id;checkbox.checked=!!(state.gravurService&&hasArt&&id);
    return checkbox.checked?id:'';
  }
  window.HHGravur=Object.freeze({file:portableFile,restored,placed,parse:artGeometry,originals,appendArts,servicePanel,cartWithService,serviceMatches,verified:uploaded,safeName});

  window.HHBoardSvg=Object.freeze({bind,sync,attach,uploaded,service,cartWithService,serviceMatches});
})();
